export const sendSupportMail = () => {
  window.location.href = Buffer.from(
    "bWFpbHRvOnN1cHBvcnRAZnJvbnRlbmRlci5pbw==",
    "base64"
  ).toString()
  return false
}
